/* eslint-disable jsx-a11y/anchor-is-valid */
import Link from "next/link";
import { createElement } from "react";
import styles from "../accessories-make/accessories-make.module.scss";

function ManufacturerCard(props: any) {
  const { data, labelKey, renderChildren } = props;

  const renderComponent = (each: any) => (
    <Link key={each.url} href={each.url}>
      { renderChildren ? createElement(renderChildren, { ...each }) : <span className={`${styles.subcategory} col-xs-6 col-md-4 col-lg-3`}>{each[labelKey]}</span>}
    </Link>
  );

  return (
    <div className="row">
      {data
        .filter((each: any) => Boolean(each.url))
        .map((each: any) => renderComponent(each))}
    </div>
  );
}

export default ManufacturerCard;
